import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { darkColors, lightColors } from "../../theme/colors";
import { Flex, Box } from "../Box";
import { StyledFooter, StyledIconMobileContainer, StyledSocialLinks, StyledToolsContainer } from "./styles";
import { ThemeSwitcher } from "../ThemeSwitcher";
import LangSelector from "../LangSelector/LangSelector";
import { LogoWithTextIcon, ArrowForwardIcon } from "../Svg";
import { Button } from "../Button";
var MenuItem = function(_param) {
    var isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        p: [
            "40px 16px",
            null,
            "16px 60px 16px 60px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "100%"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsxs(Box, {
                        display: [
                            "block",
                            null,
                            "none"
                        ],
                        children: [
                            " ",
                            /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                                isDark: isDark,
                                width: "100%"
                            }),
                            " ",
                            /*#__PURE__*/ _jsx(StyledSocialLinks, {
                                justifyContent: "center",
                                order: [
                                    2
                                ],
                                pb: [
                                    "42px",
                                    null,
                                    "32px"
                                ],
                                mb: [
                                    "70px",
                                    null,
                                    "20px"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "center",
                    alignItems: "center",
                    mb: [
                        "42px",
                        null,
                        "16px"
                    ],
                    children: /*#__PURE__*/ _jsxs(Box, {
                        display: [
                            "none",
                            null,
                            "block"
                        ],
                        children: [
                            " ",
                            /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                                isDark: isDark,
                                width: "100%"
                            }),
                            " ",
                            /*#__PURE__*/ _jsx(StyledSocialLinks, {
                                justifyContent: "center",
                                order: [
                                    2
                                ],
                                pb: [
                                    "42px",
                                    null,
                                    "32px"
                                ],
                                mb: [
                                    "70px",
                                    null,
                                    "20px"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(StyledToolsContainer, {
                    order: [
                        1,
                        null,
                        1
                    ],
                    flexDirection: [
                        "row",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                1,
                                null,
                                1
                            ],
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(ThemeSwitcher, {
                                    isDark: isDark,
                                    toggleTheme: toggleTheme
                                }),
                                /*#__PURE__*/ _jsx(LangSelector, {
                                    currentLang: currentLang,
                                    langs: langs,
                                    setLang: setLang,
                                    color: darkColors.textSubtle,
                                    dropdownPosition: "top-right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                2,
                                null,
                                2
                            ],
                            mb: [
                                "14px",
                                null,
                                "0"
                            ],
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                isDark && /*#__PURE__*/ _jsx(Button, {
                                    as: "a",
                                    href: "https://moon.biz/swap",
                                    target: "_blank",
                                    width: "91px",
                                    height: "48px",
                                    variant: "danger",
                                    endIcon: /*#__PURE__*/ _jsx(ArrowForwardIcon, {
                                        color: lightColors.background
                                    }),
                                    children: buyCakeLabel
                                }),
                                !isDark && /*#__PURE__*/ _jsx(Button, {
                                    as: "a",
                                    href: "https://moon.biz/swap",
                                    target: "_blank",
                                    width: "91px",
                                    height: "48px",
                                    variant: "primarydark",
                                    endIcon: /*#__PURE__*/ _jsx(ArrowForwardIcon, {
                                        color: "#0B3D91"
                                    }),
                                    children: buyCakeLabel
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
